/**
 * ---------------------------------------------------------------------------
 * General
 * ---------------------------------------------------------------------------
 */
export const COVER_PLACEHOLDER_SRC = '/assets/svg/no-cover.svg'
export const INFINITE_SCROLL_ROOT_MARGIN = '700px'
export const INFINITE_SCROLL_PAGE_SIZE = 50
export const ACTIVITY_WINDOW_DAYS = 90
export const SCROLL_TOP_SHOW_THRESHOLD_PX = 400
export const SCROLL_TOP_SHOW_DELAY_MS = 400
export const SNACKBAR_DURATION_MS = 3000
export const PUBLIC_SUPPORT_EMAIL = 'tunetoss@proton.me'

export const DISCOGS_AUTH_PATH = '/auth/discogs'

/**
 * ---------------------------------------------------------------------------
 * History
 * ---------------------------------------------------------------------------
 * Maximum number of months a release can be hidden via dialogs.
 */
export const HIDE_DURATION_MONTHS_MAX = 24

/**
 * ---------------------------------------------------------------------------
 * Shuffle
 * ---------------------------------------------------------------------------
 */
// Upper bound for the sampled releases fetched for shuffle animation/input.
export const SHUFFLE_SAMPLE_LIMIT_MAX = 200
// Number of releases prepared for one carousel run.
export const SHUFFLE_SAMPLE_LIMIT = 48
// Time for one cover to travel through the carousel while spinning.
export const SHUFFLE_CAROUSEL_ITEM_DURATION_MS = 250
// Slowdown after the user stops the shuffle before locking onto the winner.
export const SHUFFLE_STOP_DECELERATION_MS = 2000
// Delay used between staged reveal steps (winner -> header -> actions -> full content).
export const SHUFFLE_REVEAL_DELAY_MS = 700

/**
 * ---------------------------------------------------------------------------
 * Sync / Cache
 * ---------------------------------------------------------------------------
 */
export const SESSION_MAX_AGE_MS = 14 * 24 * 60 * 60 * 1000 // 14 Days
export const PREVIEW_CACHE_TTL_HOURS = 12
export const PREVIEW_CACHE_MAX_ENTRIES = 500
export const DISCOGS_CACHE_FRESHNESS_MS = (5 * 60 + 45) * 60 * 1000 // 5h 45m
export const ACTIVE_USER_WINDOW_MS = 14 * 24 * 60 * 60 * 1000 // 14 Days
export const USER_ACTIVITY_WRITE_THROTTLE_MS = 15 * 60 * 1000 // 15m
export const COLLECTION_PREWARM_INTERVAL_MS = 30 * 60 * 1000 // 30m
export const COLLECTION_PREWARM_SYNC_AGE_MS = (5 * 60 + 15) * 60 * 1000 // 5h 15m
export const COLLECTION_PREWARM_MAX_USERS_PER_RUN = 10
export const COLLECTION_USER_SYNC_COOLDOWN_MS = 2 * 60 * 1000 // 2m
// export const RELEASE_DETAILS_TTL_MS = 0;
export const RELEASE_DETAILS_CACHE_VERSION = 2
export const RELEASE_DETAILS_TTL_MS = DISCOGS_CACHE_FRESHNESS_MS
/**
 * ---------------------------------------------------------------------------
 * Error Codes
 * ---------------------------------------------------------------------------
 */
export const ERR_COLLECTION_SYNC_FAILED = 'COLLECTION_SYNC_FAILED'
